import React, { useState } from 'react';
import { Filter } from 'lucide-react';

/**
 * FilterToggle — Trigger that expands/collapses the filter row.
 * Spec: design-system.md Section 7.15 + Section 8 (Filter Toggle)
 *
 * Props:
 *   isExpanded: boolean — whether the filter row is currently visible
 *   onToggle: () => void — called when the trigger is clicked
 *   activeCount: number — number of currently selected filter pills
 *   accent: string — hex color for the app accent (badge background + active icon)
 */
export default function FilterToggle({ isExpanded, onToggle, activeCount = 0, accent = '#6B35B8' }) {
  const [hovering, setHovering] = useState(false);

  const iconColor = isExpanded ? accent : hovering ? '#b0b4c0' : '#6b7084';

  return (
    <button
      type="button"
      onClick={onToggle}
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={() => setHovering(false)}
      style={{
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 8,
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        flexShrink: 0,
      }}
      aria-label={isExpanded ? 'Hide filters' : 'Show filters'}
    >
      <Filter
        size={18}
        strokeWidth={1.5}
        style={{ color: iconColor, transition: 'color 150ms ease' }}
      />
      {activeCount > 0 && (
        <span
          style={{
            position: 'absolute',
            top: -2,
            right: -2,
            width: 14,
            height: 14,
            borderRadius: '50%',
            background: accent,
            color: '#ffffff',
            fontFamily: "'Inter', sans-serif",
            fontSize: 10,
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            lineHeight: 1,
          }}
        >
          {activeCount}
        </span>
      )}
    </button>
  );
}
